import { useCallback, useEffect, useState } from 'react'
import { io } from 'socket.io-client'

import { useToast } from '../../../components/shared/toast/toast.hooks'
import { SOCKET_URLS } from '@hapana/shared/constants/socket.constants'
import { SOCKET_EVENTS } from '@hapana/shared/constants/socket.constants'

import { WEBSOCKET } from './wesocket.constant'

export const useWebSocket = (props) => {
  const [isConnected, setIsConnected] = useState(false)
  const { openToast } = useToast()
  const [socket, setSocket] = useState(null)

  useEffect(() => {
    setSocket(
      io(SOCKET_URLS[process.env.ENVIRONMENT || 'qa'], {
        path: WEBSOCKET.path,
        reconnectionAttempts: WEBSOCKET.reconnAttempt,
        reconnectionDelay: WEBSOCKET.reconnDelay,
        transports: WEBSOCKET.transport,
        auth: {
          idToken: props?.token,
          authMechanism: props.authMechanism ? props.authMechanism : WEBSOCKET.authMechanism,
          tenant: props?.tenant,
          userId: props.userId,
        },
      })
    )
  }, [props?.tenant, props?.token, props.userId, props?.authMechanism])

  const connect = useCallback(() => socket?.connect?.(), [socket])

  const disconnect = useCallback(() => socket?.disconnect?.(), [socket])

  useEffect(() => {
    if (socket && !isConnected) {
      const handleConnect = () => setIsConnected(true)
      const handleDisconnect = () => setIsConnected(false)

      socket?.on?.(SOCKET_EVENTS.connect, handleConnect)
      socket?.on?.(SOCKET_EVENTS.disconnect, handleDisconnect)
      return () => {
        socket?.off?.(SOCKET_EVENTS.connect, handleConnect)
        socket?.off?.(SOCKET_EVENTS.disconnect, handleDisconnect)
      }
    }
  }, [socket, disconnect, openToast, isConnected])

  useEffect(() => {
    connect()
    const timeout = setTimeout(
      () => {
        disconnect()
      },
      20 * 60 * 1000
    )
    return () => {
      clearTimeout(timeout)
    }
  }, [connect, disconnect])

  return {
    socket,
    isConnected,
  }
}
